// Lunch / dinner re-pick rules for generated itineraries.
//
// A meal slot is only kept when it is a food venue AND close enough to where the
// traveller already is. Being tagged "food" is not enough: a Gion restaurant was
// kept for a lunch that followed an Arashiyama morning (8.7 km apart) while the
// activity text still said "lunch in Arashiyama".
import { haversineKm } from './geo';

export const MEAL_RADIUS_KM = 5;      // 重選時，新餐廳離錨點的上限
export const FULL_DAY_MEAL_KM = 10;   // 整天地點（Outlet、主題樂園）那天，午餐離場地的上限
export const MEAL_FAR_KM = 7;         // 一般日子，午／晚餐離前一站超過這個距離就重選（比 MEAL_RADIUS_KM 寬，避免來回抖動）

// 非即日來回日的午／晚餐：回傳要不要保留，以及重選時的錨點與半徑。
export function mealRepickPlan({ slotCoord, isFood, fullDayCoord, prevCoord, nextCoord }) {
  const lunchTooFar = !!fullDayCoord && (!slotCoord || haversineKm(fullDayCoord, slotCoord) > FULL_DAY_MEAL_KM);
  const farFromPrev = !!prevCoord && !!slotCoord && haversineKm(prevCoord, slotCoord) > MEAL_FAR_KM;
  return {
    keep: !!isFood && !lunchTooFar && !farFromPrev,
    lunchTooFar,
    farFromPrev,
    anchor: lunchTooFar ? fullDayCoord : (prevCoord || nextCoord || slotCoord || null),
    radiusKm: lunchTooFar ? FULL_DAY_MEAL_KM : MEAL_RADIUS_KM,
  };
}

// 錨點 radiusKm 內、未用過的餐廳，最近優先、同距離看評分；沒有就回 null。
export function pickNearestFood({ anchor, radiusKm, pool, isUsed }) {
  if (!anchor) return null;
  return pool
    .filter(v => !isUsed(v))
    .map(v => ({ v, distKm: haversineKm(anchor, { lat: v.lat, lng: v.lng }) }))
    .filter(x => x.distKm <= radiusKm)
    .sort((a, b) => a.distKm - b.distKm || (Number(b.v.rating) || 0) - (Number(a.v.rating) || 0))[0]?.v || null;
}
